import Hotjar from '@hotjar/browser'

const siteId = process.env.REACT_APP_HOTJAR_ID
const hotjarVersion = 6

Hotjar.init(siteId as unknown as number, hotjarVersion as number, {
  debug: true
})

export default Hotjar
